import { useState, useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './header.module.css';
import { FaSearch, FaTimes, FaBell } from 'react-icons/fa';
import { API_URL } from '../Utils/api';
import { useUserInfo } from '../hooks/useUserInfo';

const Header = ({ pp, active, setActive, setShowPublishMenu }) => {
  const navigate = useNavigate();

  const [searchQuery,  setSearchQuery]  = useState('');
  const [mobileSearch, setMobileSearch] = useState(false);
  const [userData,     setUserData]     = useState(null);
  const [isMobile,     setIsMobile]     = useState(false);

  const desktopInputRef = useRef(null);
  const mobileInputRef  = useRef(null);

  const token    = localStorage.getItem('token');
  const userId   = localStorage.getItem('userId');
  const username = localStorage.getItem('username') || 'Utilisateur';

  /* ── Mobile detection ── */
  useEffect(() => {
    const check = () => {
      const ua = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
      setIsMobile(ua || window.innerWidth <= 768);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  const { data, error, isLoading } = useUserInfo(token);
  useEffect(() => {
    
    if (data) {
      setUserData(data)
    }
  }, []);

  

  useEffect(() => {
    if ('Notification' in window && 'serviceWorker' in navigator) {
      Notification.requestPermission()
        .then((permission)=>{
          if (permission === "granted"){
            console.log('Permission accordée')
          } else{
            console.log("Permission refusée")
          }
        })
        .catch(()=>{
          console.log("Erreur lors de la demande de permission")
        })
    }
  }, []);


  /* ── Focus l'input mobile quand l'overlay s'ouvre ── */
  useEffect(() => {
    if (mobileSearch) {
      setTimeout(() => mobileInputRef.current?.focus(), 50);
    }
  }, [mobileSearch]);

  /* ── Submit ── */
  const handleSearch = useCallback((e) => {
    e.preventDefault();
    if (!searchQuery.trim()) return;
    navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    setSearchQuery('');
    setMobileSearch(false);
  }, [searchQuery, navigate]);

  const handleNav = useCallback((id) => {
    setActive(id);
    setMobileSearch(false);
    if (id === 'home') navigate('/home');
  }, [setActive, navigate]);

  return (
    <>
      <header className={styles.header}>

        {/* Logo */}
        <div className={styles.logo} onClick={() => handleNav('home')} role="button">
          <h2 >agora</h2>
        </div>

        {/* ── Barre de recherche desktop ── */}
        {/* ✅ définie directement ici, pas dans un sous-composant → pas de remount */}
        <div className={styles.searchDesktop}>
          <form className={styles.searchContainer} onSubmit={handleSearch}>
            <FaSearch className={styles.searchIcon} />
            <input
              ref={desktopInputRef}
              type="text"
              placeholder="Rechercher sur Agora..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              aria-label="Rechercher"
            />
            {searchQuery && (
              <button
                type="button"
                className={styles.clearBtn}
                onClick={() => { setSearchQuery(''); desktopInputRef.current?.focus(); }}
                aria-label="Effacer la recherche"
              >
                <FaTimes />
              </button>
            )}
            {/* ✅ Bouton de recherche visible */}
            <button type="submit" className={styles.searchSubmitBtn} aria-label="Lancer la recherche">
              <FaSearch />
            </button>
          </form>
        </div>

        {/* ── Actions droite ── */}
        <div className={styles.actions}>

          {/* Loupe mobile 
          <button
            className={styles.mobileOnly}
            onClick={() => setMobileSearch(v => !v)}
            aria-label="Ouvrir la recherche"
          >
            <FaSearch />
          </button>*/}

          {/* Avatar */}
          <button
            className={styles.avatarBtn}
            onClick={() => navigate(`/profile/${userId}`)}
            aria-label="Profil"
          >
            {data?.userPP ? (
              <img src={data.userPP} alt={username} />
            ) : (
              <div className={styles.avatarPlaceholder}>
                {username.charAt(0).toUpperCase()}
              </div>
            )}
          </button>
        </div>
      </header>

      {/* ── Overlay search mobile ── */}
      {mobileSearch && (
        <div className={styles.mobileSearchOverlay}>
          <button
            className={styles.mobileBackBtn}
            onClick={() => { setMobileSearch(false); setSearchQuery(''); }}
            aria-label="Retour"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
            </svg>
          </button>

          {/* ✅ Input mobile séparé avec sa propre ref — pas de remount */}
          <form className={`${styles.searchContainer} ${styles.mobileSearchForm}`} onSubmit={handleSearch}>
            <FaSearch className={styles.searchIcon} />
            <input
              ref={mobileInputRef}
              type="text"
              placeholder="Rechercher..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              aria-label="Rechercher"
            />
            {searchQuery && (
              <button
                type="button"
                className={styles.clearBtn}
                onClick={() => { setSearchQuery(''); mobileInputRef.current?.focus(); }}
                aria-label="Effacer"
              >
                <FaTimes />
              </button>
            )}
            <button type="submit" className={styles.searchSubmitBtn} aria-label="Lancer la recherche">
              <FaSearch />
            </button>
          </form>
        </div>
      )}
    </>
  );
};

export default Header;